import { useEffect } from "react";

/**
 * useReveal — attaches a class when element enters the viewport.
 * Adds the `.in` class to elements that have the `.reveal` class.
 */
export default function useReveal(rootSelector = "[data-reveal-root]") {
  useEffect(() => {
    const targets = document.querySelectorAll(`${rootSelector} .reveal`);
    if (!targets.length) return;

    // Eagerly reveal anything already in or near the viewport
    const vh = window.innerHeight || 800;
    targets.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < vh * 0.95) {
        el.classList.add("in");
      }
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -10% 0px" }
    );

    targets.forEach((el) => {
      if (!el.classList.contains("in")) io.observe(el);
    });

    // Safety net: anything still hidden after 1.5s, just reveal
    const failsafe = window.setTimeout(() => {
      document
        .querySelectorAll(`${rootSelector} .reveal`)
        .forEach((el) => el.classList.add("in"));
    }, 1500);

    return () => {
      io.disconnect();
      window.clearTimeout(failsafe);
    };
  }, [rootSelector]);
}
